module.exports = __webpack_public_path__ + "static/media/song-a.18a702e6.jpg";